"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const isRepositoryEndpoint = (input) => {
  try {
    new URL(input);
    return true;
  } catch {
    return false;
  }
};
exports.isRepositoryEndpoint = isRepositoryEndpoint;
//# sourceMappingURL=isRepositoryEndpoint.cjs.map
